import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./Campaigns.css";

function Campaigns() {
  return (
    <div>
      <Container className="container-Campaigns">
        <Row className="justify-content-md-center mt-4">
          <h2>COMING SOON!</h2>
        </Row>
      </Container>
    </div>
  );
}
export default Campaigns;
